import { IDeleteIndiceReajusteUseCase } from "../../../presentation/useCases/delete/delete_indice_reajuste_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * DeleteIndiceReajusteUseCase
 */

export class DeleteIndiceReajusteUseCase implements IDeleteIndiceReajusteUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async deleteIndiceReajuste(idIndiceReajuste: number): Promise<void> {
    await this.repository.deleteIndiceReajuste(idIndiceReajuste);

  }
}
